/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {ChangeDetectorRef, Component, ContentChild, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {DatagridColumnToggle} from './datagrid-column-toggle';
import {HideableColumnService} from './providers/hideable-column.service';
import {Selection, SelectionType} from './providers/selection';
export class DatagridFooter implements OnInit {
/**
 * @param {?} selection
 * @param {?} hideableColumnService
 * @param {?} cdr
 */
constructor(public selection: Selection,
public hideableColumnService: HideableColumnService,
public cdr: ChangeDetectorRef) {}
public activeToggler: boolean;
private subscriptions: Subscription[] = [];
public SELECTION_TYPE = SelectionType;

     toggle: DatagridColumnToggle;
/**
 * @return {?}
 */
ngOnInit() {
        this.subscriptions.push(this.hideableColumnService.columnListChange.subscribe((change) => {
            const /** @type {?} */ hiddenColumnsInSub = change.filter(col => col);
            if (hiddenColumnsInSub.length > 0) {
                this.activeToggler = true;
            }
        }));

        const /** @type {?} */ hiddenColumns = this.hideableColumnService.getColumns().filter(col => col);

        if (hiddenColumns.length > 0) {
            this.activeToggler = true;
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.subscriptions.forEach((sub) => {
            sub.unsubscribe();
        });
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-dg-footer",
    template: `
        <ng-container
            *ngIf="(selection.selectionType === SELECTION_TYPE.Multi) && (selection.current.length > 0)">
            <clr-checkbox [clrDisabled]="true" [clrChecked]="true" class="datagrid-foot-select">
                {{selection.current.length}}
            </clr-checkbox>
        </ng-container>
        <ng-content select="clr-dg-column-toggle"></ng-content>
        <clr-dg-column-toggle *ngIf="!toggle && activeToggler"></clr-dg-column-toggle>
        <div class="datagrid-foot-description">
            <ng-content></ng-content>
        </div>
        <ng-content select="clr-dg-pagination"></ng-content>
    `,
    host: {
        "[class.datagrid-foot]": "true",
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Selection, },
{type: HideableColumnService, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'toggle': [{ type: ContentChild, args: [DatagridColumnToggle, ] },],
};
}

function DatagridFooter_tsickle_Closure_declarations() {
/** @type {?} */
DatagridFooter.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridFooter.ctorParameters;
/** @type {?} */
DatagridFooter.propDecorators;
/** @type {?} */
DatagridFooter.prototype.activeToggler;
/** @type {?} */
DatagridFooter.prototype.subscriptions;
/** @type {?} */
DatagridFooter.prototype.SELECTION_TYPE;
/** @type {?} */
DatagridFooter.prototype.toggle;
/** @type {?} */
DatagridFooter.prototype.selection;
/** @type {?} */
DatagridFooter.prototype.hideableColumnService;
/** @type {?} */
DatagridFooter.prototype.cdr;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
